import React from 'react';
import { Button, Drawer, Tabs, Modal } from 'antd';
import style from './index.scss';
import BasicInfo from './Tabs/BasicInfo';
import Formula from './Tabs/Formula';
import Functions from './Tabs/Functions';
import FilterConditions from './Tabs/FilterConditions';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;
const { confirm } = Modal;

const tabsConfig = [
  {
    componentName: <BasicInfo />,
    tabName: 'Basic Info'
  },
  {
    componentName: <Formula />,
    tabName: 'Formula'
  },
  {
    componentName: <Functions />,
    tabName: 'Functions'
  },
  {
    componentName: <FilterConditions />,
    tabName: 'Global Conditions'
  }
];

export default class ConfigureDrawer extends React.Component {
  state = { visible: false, activeTabID: 0, record: {}, isDirty: false };

  showDrawer = (defaultTab, record, typoIndex, variantIndex) => {
    this.setState({
      visible: true,
      record: {
        ...record,
        variantIndex,
        typoIndex
      },
      isDirty: false
    });
  };

  onDirtyField = () => {
    this.setState({
      isDirty: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  tabsCallback = (tabID) => {
    this.setState({ activeTabID: parseInt(tabID) });
  };

  static getDerivedStateFromProps(props, state) {
    if (state.record.variantIndex > -1) {
      const currentRecord =
        props.variantRenderData[state.record.typoIndex].variants[
          state.record.variantIndex
        ];
      if (currentRecord !== state.record) {
        return {
          record: {
            ...currentRecord,
            variantIndex: state.record.variantIndex,
            typoIndex: state.record.typoIndex
          }
        };
      }
    }
    return null;
  }

  showCancelConfirm = () => {
    if (this.props.isReadOnly || !this.state.isDirty) {
      this.onClose();
      return;
    }
    confirm({
      title: 'Do you want to cancel changes?',
      icon: <ExclamationCircleOutlined />,
      content: 'Changes done in rules will be lost.',
      onOk: () => {
        this.props.setScenarioData();
        this.onClose();
      },
      onCancel: () => {}
    });
  };

  showSaveConfirm = (typologyId) => {
    confirm({
      title: 'Save Changes!!',
      icon: <ExclamationCircleOutlined />,
      content:
        'Please check if the variant configurations are completed (Ex: Group_By) and set as per the variant.',
      onOk: () => {
        this.props.handleSaveTypology(typologyId);
        this.onClose();
      },
      onCancel: () => {}
    });
  };

  render() {
    const {
      typologies = [],
      setVariantRenderData,
      isReadOnly,
      handleSaveTypology
    } = this.props;
    const { record = {}, isDirty } = this.state;
    const {
      variantName = '',
      typologyId = '',
      variantIndex,
      typoIndex,
      typologiesReadOnly = []
    } = record;
    let selectedTypology = {};
    if (typologies.length > 0) {
      selectedTypology = typologies.find((t) => t.id === typologyId);
    } else {
      selectedTypology = typologiesReadOnly.find((t) => t.id === typologyId);
    }
    return (
      <>
        <Drawer
          title={variantName}
          width={720}
          onClose={this.showCancelConfirm}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          destroyOnClose={true}
          maskClosable={false}
          footer={
            isReadOnly ? (
              <></>
            ) : (
              <div
                style={{
                  textAlign: 'right'
                }}>
                {/* <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                  Cancel
                </Button> */}
                <Button
                  onClick={() => {
                    this.showSaveConfirm(typologyId);
                  }}
                  disabled={!isDirty}
                  type="primary">
                  Save
                </Button>
              </div>
            )
          }>
          <Tabs onChange={this.tabsCallback}>
            {tabsConfig.map((tabConfig, idX) => {
              const { componentName, tabName } = tabConfig;
              return (
                <TabPane
                  tab={
                    <span
                      className={
                        this.state.activeTabID === idX
                          ? style.tabClassActive
                          : style.tabClass
                      }>
                      {tabName}
                    </span>
                  }
                  key={idX}>
                  {React.cloneElement(componentName, {
                    typology: selectedTypology,
                    setVariantRenderData,
                    variantIndex,
                    typoIndex,
                    variantInfo: record,
                    isReadOnly,
                    onDirtyField: this.onDirtyField
                  })}
                </TabPane>
              );
            })}
          </Tabs>
        </Drawer>
      </>
    );
  }
}
